module.exports = __webpack_public_path__ + "img/check-mark.2712fe01.svg";